import { render, staticRenderFns } from "./PublicHolidays.vue?vue&type=template&id=54676968&scoped=true&"
import script from "./PublicHolidays.vue?vue&type=script&lang=js&"
export * from "./PublicHolidays.vue?vue&type=script&lang=js&"
import style0 from "./PublicHolidays.vue?vue&type=style&index=0&id=54676968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54676968",
  null
  
)

export default component.exports